var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainDiv d-flex justify-space-between pb-2 mb-2 font_31 van_color02--text"},[_c('div',[_vm._v(_vm._s(_vm.label))]),(_vm.amount === -1)?_c('div',[_vm._v("نامحدود")]):_c('div',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amount))+" "+_vm._s(_vm.currencyName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }